import Vue from 'vue'
import {
  INVITE_USER_ERROR,
  INVITE_USER_REQUEST,
  INVITE_USER_SUCCESS,
  USER_ERROR,
  USER_REQUEST,
  USER_SUCCESS,
  COMPLETE_REGISTRATION_ERROR,
  COMPLETE_REGISTRATION_REQUEST,
  COMPLETE_REGISTRATION_SUCCESS,
  CHANGE_PASSWORD_ERROR,
  CHANGE_PASSWORD_REQUEST,
  CHANGE_PASSWORD_SUCCESS
} from './actiontypes'
import authApi from '../../_services/api/authenticate'
import authUser from '../../_services/api/user'

const state = {
  user: null,
  errors: [],
  status: ''
}

const getters = {
  getUser: state => state.user
}

const actions = {
  [USER_REQUEST]: ({ commit, dispatch }, token) => {
    return new Promise((resolve, reject) => {
      commit(USER_REQUEST)
      authApi.getUser()
        .then((response) => {
          if (response.success === true) {
            commit(USER_SUCCESS, response.data);
            resolve(response);
          }
          else {
            commit(USER_ERROR, response)
            localStorage.removeItem('token')
          }
        })
        .catch((error) => {
          commit(USER_ERROR, error)
          localStorage.removeItem('token')
        })
    })
  },
  [INVITE_USER_REQUEST]: ({ commit, dispatch }, payload) => {
    return new Promise((resolve, reject) => {
      commit(INVITE_USER_REQUEST)
      authUser.inviteUser(payload)
        .then((response) => {
          if (response.success === true) {
            commit(INVITE_USER_SUCCESS, response.data)
            resolve(response);
          }
          else {
            commit(INVITE_USER_ERROR, response)
            reject(response);
          }
        })
        .catch((error) => {
          commit(INVITE_USER_ERROR, error)
          reject(error)
        })
    })
  },
  [COMPLETE_REGISTRATION_REQUEST]: ({ commit, dispatch }, payload) => {
    return new Promise((resolve, reject) => {
      commit(COMPLETE_REGISTRATION_REQUEST)
      authUser.completeRegistration(payload)
        .then((response) => {
          if (response.success === true) {
            commit(COMPLETE_REGISTRATION_SUCCESS, response.data)
            resolve(response);
          }
          else {
            commit(COMPLETE_REGISTRATION_ERROR, response)
            reject(response);
          }
        })
        .catch((error) => {
          commit(COMPLETE_REGISTRATION_ERROR, error)
          reject(error)
        })
    })
  },
  [CHANGE_PASSWORD_REQUEST]: ({ commit, dispatch }, payload) => {
    return new Promise((resolve, reject) => {
      commit(CHANGE_PASSWORD_REQUEST)
      authUser.changePassword(payload)
        .then((response) => {
          if (response.success === true) {
            commit(CHANGE_PASSWORD_SUCCESS, response.data)
            resolve(response);
          }
          else {
            commit(CHANGE_PASSWORD_ERROR, response)
            reject(response);
          }
        })
        .catch((error) => {
          commit(CHANGE_PASSWORD_ERROR, error)
          reject(error)
        })
    })
  },
}

const mutations = {
  [USER_REQUEST]: (state) => {
    state.status = 'loading'
  },
  [USER_SUCCESS]: (state, response) => {
    state.status = 'success'
    Vue.set(state, 'user', response.user);
    console.log("USER ---------");
    console.log(response.user);
    state.hasLoadedOnce = true
  },
  [USER_ERROR]: (state, response) => {
    state.status = 'error'
    state.hasLoadedOnce = true
    Vue.set(state, 'errors', response.error)
  },
  [INVITE_USER_REQUEST]: (state) => {
    state.status = 'loading'
  },
  [INVITE_USER_SUCCESS]: (state, response) => {
    state.status = 'success'
    state.hasLoadedOnce = true
  },
  [INVITE_USER_ERROR]: (state, response) => {
    state.status = 'error'
    state.hasLoadedOnce = true
    Vue.set(state, 'errors', response.error)
  },
  [COMPLETE_REGISTRATION_REQUEST]: (state) => {
    state.status = 'loading'
  },
  [COMPLETE_REGISTRATION_SUCCESS]: (state, response) => {
    state.status = 'success'
    state.hasLoadedOnce = true
  },
  [COMPLETE_REGISTRATION_ERROR]: (state, response) => {
    state.status = 'error'
    state.hasLoadedOnce = true
    Vue.set(state, 'errors', response.error)
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
